// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip_wrapper__x25Oh","tooltipWrapper":"Tooltip_tooltipWrapper__1w72i"};